
    <div class="dashboard-container">
      
        <!-- المحتوى الرئيسي -->
        <main class="main-content">
            <!-- شريط العنوان -->
            <header class="main-header">
                <div class="header-content">
                    <div class="header-title">
                        <h1>{{ 'MENU.DASHBOARD.Chat_dash' | translate }}</h1>
                        <p>{{ 'MENU.DASHBOARD.Analysis_chat' | translate }}</p>
                    </div>
                    <div class="header-actions">
                        <!-- <div class="search-box">
                            <input type="text" placeholder="">
                            <button class="search-btn">
                                <i class="fas fa-search"></i>
                            </button>
                        </div> -->
                        <div class="action-buttons">
                            <!-- <button class="btn btn-suc">
                                <i class="fas fa-plus"></i>
                                محادثة جديدة
                            </button> -->
                            <!-- <button class="btn btn-secondary">
                                <i class="fas fa-filter"></i>
                                تصفية
                            </button> -->
                        </div>
                    </div>
                </div>
            </header>

           <!-- analysis.component.html -->
                <section class="quick-stats">
                    <!-- إجمالي المحادثات -->
                    <div class="stat-card">
                        <div class="stat-icon total">
                            <i class="fas fa-comments"></i>
                        </div>
                        <div class="stat-info mx-1">
                            <h3>{{ loading ? '...' : formatNumber(analysisData.chats_count) }}</h3>
                            <p> {{ 'MENU.DASHBOARD.Total_conversations' | translate }}</p>
                            <!-- <span 
                                class="stat-change"
                                [class.up]="getChangePercentage(analysisData.chats_count, 'chats_count').class === 'up'"
                                [class.down]="getChangePercentage(analysisData.chats_count, 'chats_count').class === 'down'"
                                [class.neutral]="getChangePercentage(analysisData.chats_count, 'chats_count').class === 'neutral'"
                            >
                                {{ loading ? '...' : getChangePercentage(analysisData.chats_count, 'chats_count').value }}
                            </span> -->
                        </div>
                    </div>

                    <!-- إجمالي الرسائل -->
                    <div class="stat-card">
                        <div class="stat-icon messages">
                            <i class="fas fa-envelope"></i>
                        </div>
                        <div class="stat-info mx-1">
                            <h3>{{ loading ? '...' : formatNumber(analysisData.messages_count) }}</h3>
                            <p> {{ 'MENU.DASHBOARD.Total_messages' | translate }}</p>
                            <!-- <span 
                                class="stat-change"
                                [class.up]="getChangePercentage(analysisData.messages_count, 'messages_count').class === 'up'"
                                [class.down]="getChangePercentage(analysisData.messages_count, 'messages_count').class === 'down'"
                                [class.neutral]="getChangePercentage(analysisData.messages_count, 'messages_count').class === 'neutral'"
                            >
                                {{ loading ? '...' : getChangePercentage(analysisData.messages_count, 'messages_count').value }}
                            </span> -->
                        </div>
                    </div>

                    <!-- إجمالي الموظفين -->
                    <div class="stat-card">
                        <div class="stat-icon employees">
                            <i class="fas fa-users"></i>
                        </div>
                        <div class="stat-info mx-1">
                            <h3>{{ loading ? '...' : formatNumber(analysisData.employees_count) }}</h3>
                            <p> {{ 'MENU.DASHBOARD.Total_employee' | translate }}</p>
                            <!-- <span 
                                class="stat-change"
                                [class.up]="getChangePercentage(analysisData.employees_count, 'employees_count').class === 'up'"
                                [class.down]="getChangePercentage(analysisData.employees_count, 'employees_count').class === 'down'"
                                [class.neutral]="getChangePercentage(analysisData.employees_count, 'employees_count').class === 'neutral'"
                            >
                                {{ loading ? '...' : getChangePercentage(analysisData.employees_count, 'employees_count').value }}
                            </span> -->
                        </div>
                    </div>

                    <!-- إجمالي المستثمرين -->
                    <div class="stat-card">
                        <div class="stat-icon investors">
                            <i class="fas fa-user-tie"></i>
                        </div>
                        <div class="stat-info mx-1">
                            <h3>{{ loading ? '...' : formatNumber(analysisData.investors_count) }}</h3>
                            <p> {{ 'MENU.DASHBOARD.Total_investors' | translate }}</p>
                            <!-- <span 
                                class="stat-change"
                                [class.up]="getChangePercentage(analysisData.investors_count, 'investors_count').class === 'up'"
                                [class.down]="getChangePercentage(analysisData.investors_count, 'investors_count').class === 'down'"
                                [class.neutral]="getChangePercentage(analysisData.investors_count, 'investors_count').class === 'neutral'"
                            >
                                {{ loading ? '...' : getChangePercentage(analysisData.investors_count, 'investors_count').value }}
                            </span> -->
                        </div>
                    </div>
                </section>
            <!-- قسم المحادثات النشطة -->
            <section class="conversations-section">
                <div class="section-header">
                    <h2>{{ 'MENU.DASHBOARD.last_chat' | translate }}</h2>
                   
                </div>

                <div class="conversations-grid" id="conversationsView">
                
                   <!-- محادثة 1 -->
                    <div class="conversation-card active" *ngFor="let item of chatData" >
                        <div class="card-header">
                            <div class="employee-info">
                                <div class="avatar">
                                    <img [src]="item.user_one?.image" alt=" ">
                                    <span class="online-status"></span>
                                </div>
                                <div class="info mx-1">
                                    <h4> {{item.user_one?.name}}</h4>
                                    <p> {{item.user_one?.type}}</p>
                                </div>
                            </div>
                            <div class="conversation-meta">
                                <span class="status-badge" >
                      {{ 'MENU.DASHBOARD.active' | translate }}
                                </span>                    

                                </div>
                        </div>
                         <div class="card-header">
                            <div class="employee-info">
                                <div class="avatar">
                                    <img [src]="item.user_two?.image" alt="فاطمة علي">
                                    <span class="online-status"></span>
                                </div>
                                <div class="info mx-1">
                                    <h4>{{item.user_two?.name}}</h4>
                                    <p> {{item.user_two?.type}}</p>
                                </div>
                            </div>
                            <div class="conversation-meta">
                               <span class="status-badge" >{{ 'MENU.DASHBOARD.active' | translate }}</span> 
                            </div>
                        </div>

                        <!-- <div class="conversation-preview">
                            <div class="investor-info">
                                <i class="fas fa-building"></i>
                                <span class="time">منذ 12 دقيقة</span>
                            </div>
                        </div> -->

                        <div class="conversation-stats">
                            <div class="stat">
                                <i class="fas fa-clock"></i>
                                <span> {{ formatDateTime(item.last_message_time) }} </span>
                            </div>
                            <div class="stat">
                                <i class="fas fa-exchange-alt"></i>
                                <!-- <span>24 رسالة</span> -->
                            </div>
                           
                        </div>

                        <div class="card-actions">
                           
                            <button class="btn-action btn-suc" (click)="sendChatId(item.chat_id)" >
                                <i class="fas fa-sign-in-alt"></i>
                              {{ 'MENU.DASHBOARD.detailes' | translate }}
                            </button>
                        </div>
                    </div>
                    
                </div>
            </section>

            <!-- قسم أداء الموظفين -->
            <!-- <section class="employees-performance">
                <div class="section-header">
                    <h2>أداء الموظفين</h2>
                    <button class="btn btn-outline">
                        <i class="fas fa-chart-bar"></i>
                        عرض التقارير التفصيلية
                    </button>
                </div>

                <div class="performance-grid">
                    <div class="employee-card">
                        <div class="employee-header">
                            <div class="avatar">
                                <img src="https://i.pravatar.cc/150?img=5" alt="أحمد محمد">
                                <span class="online-status"></span>
                            </div>
                            <div class="employee-info">
                                <h4>أحمد محمد</h4>
                                <p>مدير مشاريع</p>
                                <div class="rating">
                                    <i class="fas fa-star"></i>
                                    <span>4.8</span>
                                </div>
                            </div>
                        </div>

                        <div class="performance-stats">
                            <div class="stat">
                                <span class="value">24</span>
                                <span class="label">محادثة نشطة</span>
                            </div>
                            <div class="stat">
                                <span class="value">156</span>
                                <span class="label">مكتملة</span>
                            </div>
                            <div class="stat">
                                <span class="value">94%</span>
                                <span class="label">رضا العملاء</span>
                            </div>
                        </div>

                        <div class="current-conversations">
                            <h5>المحادثات النشطة:</h5>
                            <div class="conversation-item">
                                <span class="investor">شركة التقنية</span>
                                <span class="duration">25 د</span>
                            </div>
                            <div class="conversation-item">
                                <span class="investor">مجموعة النهضة</span>
                                <span class="duration">18 د</span>
                            </div>
                        </div>
                    </div>

                    <div class="employee-card">
                        <div class="employee-header">
                            <div class="avatar">
                                <img src="https://i.pravatar.cc/150?img=8" alt="فاطمة علي">
                                <span class="online-status"></span>
                            </div>
                            <div class="employee-info">
                                <h4>فاطمة علي</h4>
                                <p>مستشارة استثمار</p>
                                <div class="rating">
                                    <i class="fas fa-star"></i>
                                    <span>4.9</span>
                                </div>
                            </div>
                        </div>

                        <div class="performance-stats">
                            <div class="stat">
                                <span class="value">18</span>
                                <span class="label">محادثة نشطة</span>
                            </div>
                            <div class="stat">
                                <span class="value">142</span>
                                <span class="label">مكتملة</span>
                            </div>
                            <div class="stat">
                                <span class="value">96%</span>
                                <span class="label">رضا العملاء</span>
                            </div>
                        </div>

                        <div class="current-conversations">
                            <h5>المحادثات النشطة:</h5>
                            <div class="conversation-item">
                                <span class="investor">الاستثمار الوطني</span>
                                <span class="duration">42 د</span>
                            </div>
                        </div>
                    </div>

                    <div class="employee-card">
                        <div class="employee-header">
                            <div class="avatar">
                                <img src="https://i.pravatar.cc/150?img=11" alt="خالد إبراهيم">
                                <span class="online-status away"></span>
                            </div>
                            <div class="employee-info">
                                <h4>خالد إبراهيم</h4>
                                <p>محلل استثمار</p>
                                <div class="rating">
                                    <i class="fas fa-star"></i>
                                    <span>4.5</span>
                                </div>
                            </div>
                        </div>

                        <div class="performance-stats">
                            <div class="stat">
                                <span class="value">12</span>
                                <span class="label">محادثة نشطة</span>
                            </div>
                            <div class="stat">
                                <span class="value">98</span>
                                <span class="label">مكتملة</span>
                            </div>
                            <div class="stat">
                                <span class="value">89%</span>
                                <span class="label">رضا العملاء</span>
                            </div>
                        </div>

                        <div class="current-conversations">
                            <h5>المحادثات النشطة:</h5>
                            <div class="conversation-item needs-followup">
                                <span class="investor">مؤسسة التنمية</span>
                                <span class="duration">48 س</span>
                            </div>
                            <div class="conversation-item">
                                <span class="investor">شركة الأفق</span>
                                <span class="duration">15 د</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section> -->
        </main>
    </div>

